import React from 'react'
import { use, api } from 'xadmin'
import { message, Avatar, Button } from 'antd'
import _ from 'lodash'

const wechatQrcode = props => {
  const [ qrcode, setQrcode ] = React.useState('')
  const { settings } = use('settings')
  const { user } = use('redux', state => ({ user: state.user }))
  const [ openid, setOpenid ] = React.useState({ show: false, id: null })

  React.useEffect(() => { ( async () => {
      if(settings?.wechat?.appid && settings?.wechat?.secret) {
        let id = await getUserOpenid(user)
        setOpenid({ ...openid, id })
        api({ name: 'core/wechat/qrcode' })
          .fetch('', { method: 'POST' })
          .then(({ json }) => {
            json?.ticket && setQrcode(`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${json.ticket}`)
          })
      }else {
        message.info('请先配置公众号ID及密钥')
      }
    })()
  }, [ settings.wechat, user?.userId ])

  const getUserOpenid = (user) => {
    return api({ name: `core/user/${user.userId}` }).fetch('', {}).then(({ json }) => { return json?.openid })
  }
  
  const unbindWx = () => {
    api({ name: `core/user/${user.userId}` }).fetch('', { method: 'PATCH', body: JSON.stringify({ openid: '' }) })
      .then(({ json }) => { 
        message.success('解除成功！')
        setOpenid({ openid: '', show: !openid.show })
       })
  }

  return (
    <>
      {
        openid?.id ? <div style={{ padding: '2rem' }}>
          <p>已绑定微信，openid: {openid?.id}</p>
          <Button onClick={() => { unbindWx() } }>解除</Button>
        </div> : <div style={{ margin: '30px 0 0 30px' }}>
        <img src={qrcode} alt="" style={{ width: '200px' }}/>
      </div>
      }
    </>
    )
}

export default {
  name: 'iot-wechat',
  'user.schema': app => ({ data: currentUser }, cb) => {
    const { state } = use('redux')
    let user = state.user
    if(currentUser?.id == user?.userId) {
      cb(null, {
        name: 'wechatQrcode',
        title: '微信绑定',
        type: 'object',
        showInList: false,
        renderComponent: wechatQrcode
      })
    }else {
      cb(null)
    }
  }
}
